import React from "react";
import OtpVerify from "Pages/Otp-verification";

const OtpVerifytheme = () => {
  return (
    <React.Fragment>
      <OtpVerify />
    </React.Fragment>
  );
};

export default OtpVerifytheme;
